import { useFormContext } from "react-hook-form";
import { formatQuarters } from "../utils";

type Props = {
  prefix: string;
};

export const THeader = ({ prefix }: Props) => {
  const { getValues } = useFormContext();

  return (
    <div className="buh-table-header">
      <div className="cell"></div>
      <div className="cell code">Код</div>
      {getValues(prefix).periods.map((quoter) => (
        <div key={quoter} className="cell report">
          {formatQuarters(quoter)}
        </div>
      ))}
    </div>
  );
};
